import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import './style.css';

interface MarkdownProps {
  children: string;
}

const Markdown: React.FC<MarkdownProps> = ({ children }) => (
  <ReactMarkdown
    data-testid="markdown"
    className="custom-markdown"
    rehypePlugins={[rehypeRaw]}
  >
    {children}
  </ReactMarkdown>
);

export default Markdown;
